import { Box, Card, CardContent, CircularProgress, Paper, Typography } from '@mui/material';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import MessagesFilters from './messagesFilters';
import { formatMonthLabel } from './messagesUtils';

const MessagesTrendsSection = ({
  monthlyTrends,
  chartsLoading,
  monthRange,
  startMonth,
  endMonth,
  subscription,
  onMonthRangeChange,
  onStartMonthChange,
  onEndMonthChange,
  onSubscriptionChange,
}) => {
  const chartData = (monthlyTrends || []).map((row) => ({
    month: formatMonthLabel(row.month),
    total: row.total ?? 0,
    userMessages: row.userMessages ?? 0,
    followUpMessages: row.followUpMessages ?? 0,
  }));

  return (
    <Box sx={{ mt: 3 }}>
      <Paper>
        <Box sx={{ p: 2 }}>
          <Typography variant="h6" sx={{ fontSize: 20, mb: 1 }}>
            Monthly Message Trends
          </Typography>
          <MessagesFilters
            monthRange={monthRange}
            startMonth={startMonth}
            endMonth={endMonth}
            subscription={subscription}
            onMonthRangeChange={onMonthRangeChange}
            onStartMonthChange={onStartMonthChange}
            onEndMonthChange={onEndMonthChange}
            onSubscriptionChange={onSubscriptionChange}
          />
        </Box>

        <Card sx={{ m: 2, mt: 0, backgroundColor: '#f9f9f9' }}>
          <CardContent>
            {chartsLoading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
                <CircularProgress />
              </Box>
            ) : chartData.length === 0 ? (
              <Typography color="textSecondary" sx={{ textAlign: 'center', py: 4 }}>
                No messages for the selected period.
              </Typography>
            ) : (
              <ResponsiveContainer width="100%" height={320}>
                <BarChart data={chartData} margin={{ top: 8, right: 16, left: 0, bottom: 8 }}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="month" />
                  <YAxis allowDecimals={false} />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="total" name="Total" fill="#003ABA" />
                  <Bar dataKey="userMessages" name="User" fill="#5B8DEF" />
                  <Bar dataKey="followUpMessages" name="Follow-up" fill="#7588B7" />
                </BarChart>
              </ResponsiveContainer>
            )}
          </CardContent>
        </Card>
      </Paper>
    </Box>
  );
};

export default MessagesTrendsSection;
